<form [formGroup]="topDownValuationForm" (keydown)="onGridKeydown($event)">
    <mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'fund-report-valuation'" [commentSlug]="'fund-top-down-valuation'">
        @let topDownValuation = topDownValuation$ | async;
        @let isEditable = topDownValuation?.isEditable;
        @let fundVal = topDownValuation?.fundValuation;
        @let fv = fundVal?.data;
        @let saveBlock = saveBlock$ | async;
        <mat-card-header class="detail-card-header">
            <mat-card-title data-test="title">Top-Down Valuation</mat-card-title>
        </mat-card-header>
        @if ((isUndrawnComplete$ | async) === false) {
            <mat-card-content class="detail-card-content">
                <valumize-info-panel [appearance]="'INFO'"
                                     [message]="'Undrawn valuation is required. Please complete it to start a top-down valuation.'"></valumize-info-panel>
            </mat-card-content>
        } @else {
            <mat-card-content class="detail-card-content">
                @if (fundVal && fundVal.status === 'ERROR') {
                    <valumize-info-panel [appearance]="'ERROR'" [message]="fundVal.errorMessage"></valumize-info-panel>
                }
                @if (topDownValuation) {
                    <div class="key-value-pair-section">
                        <div class="key-value-pair-column">
                            <div>
                                <div class="key-value-pair">
                                    <div class="key-value-item required-asterisk">Required gIRR</div>
                                    <div class="key-value-item">
                                        @let requiredGrossIRRSource = fv?.requiredGrossIRR?.source;
                                        @if (isEditable) {
                                            <span class="value-with-gear">
                                                <valumize-source-gear [source]="requiredGrossIRRSource"></valumize-source-gear>
                                                <div>
                                                    <input matInput
                                                           class="input-number-narrow"
                                                           type="text"
                                                           inputmode="decimal"
                                                           formControlName="requiredGrossIRR"
                                                           id="requiredGrossIRR"
                                                           (change)="calc('requiredGrossIRR')">
                                                </div>
                                            </span>
                                        } @else {
                                            <span class="value-with-gear">
                                                <valumize-source-gear [source]="requiredGrossIRRSource"></valumize-source-gear>
                                                {{ fv?.requiredGrossIRR | traceableFormat }}
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div class="key-value-pair">
                                    <div class="key-value-item required-asterisk">Fund Term Extension in Month</div>
                                    <div class="key-value-item">
                                        @if (isEditable) {
                                            <div>
                                                <div>
                                                    <input matInput
                                                           class="input-number-narrow"
                                                           type="text"
                                                           inputmode="decimal"
                                                           formControlName="fundTermExtensionInMonth"
                                                           id="fundTermExtensionInMonth"
                                                           (change)="calc('fundTermExtensionInMonth')">
                                                </div>
                                            </div>
                                        } @else {
                                            @if (fv?.fundTermExtensionInMonth) {
                                                {{ fv?.fundTermExtensionInMonth }}
                                            } @else {
                                                -
                                            }
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="key-value-pair-column">
                            <div>
                                <div class="key-value-pair">
                                    <div class="key-value-item">Total Reported NAV</div>
                                    <div class="key-value-item">
                                        {{ topDownValuation.selectedFundReport.fundReport.data.totalReportedNav | traceableFormat }}
                                    </div>
                                </div>
                                <div class="spacer"></div>
                                <div class="key-value-pair">
                                    <div class="key-value-item">Calculated Bid Price</div>
                                    <div class="key-value-item">
                                        {{ fv?.calculatedBidPrice | traceableFormat }}
                                    </div>
                                </div>
                                <div class="key-value-pair" style="border-bottom: 1px solid black">
                                    <div class="key-value-item">Bid Price Adjustment</div>
                                    <div class="key-value-item">
                                        @if (isEditable) {
                                            <div>
                                                <div>
                                                    <input matInput
                                                           class="input-number-narrow"
                                                           type="text"
                                                           inputmode="decimal"
                                                           formControlName="bidPriceAdjustment"
                                                           id="bidPriceAdjustment"
                                                           (change)="calc('bidPriceAdjustment')">
                                                </div>
                                            </div>
                                        } @else {
                                            {{ fv?.bidPriceAdjustment | traceableFormat }}
                                        }
                                    </div>
                                </div>
                                <div class="key-value-pair">
                                    <div class="key-value-item">Final Bid Price</div>
                                    <div class="key-value-item">
                                        {{ fv?.finalBidPrice | traceableFormat }}
                                    </div>
                                </div>
                                <div class="spacer"></div>
                                <div class="key-value-pair">
                                    <div class="key-value-item">Discount to NAV</div>
                                    <div class="key-value-item">
                                        {{ fv?.discountToNAV | traceableFormat }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table mat-table [dataSource]="topDownValuation.tableDatasource" [trackBy]="trackByScenarioCode">
                        <ng-container matColumnDef="case" sticky>
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell class="required-asterisk" *matCellDef="let element">{{ element.scenario.code | codeFormat: codeTableScenarioType | async }}</td>
                        </ng-container>

                        <ng-container matColumnDef="probability">
                            <th mat-header-cell *matHeaderCellDef>Probability</th>
                            <td mat-cell *matCellDef="let element">{{ element.probability | traceableFormat }}</td>
                        </ng-container>

                        <ng-container matColumnDef="totalCashflow">
                            <th mat-header-cell *matHeaderCellDef>Total Exit Cashflow</th>
                            <td mat-cell *matCellDef="let element">
                                @if (isEditable) {
                                    <input matInput
                                           class="input-number-narrow"
                                           type="text"
                                           inputmode="decimal"
                                           formControlName="totalCashflow{{element.scenario.code}}"
                                           id="totalCashflow{{element.scenario.code}}"
                                           (change)="calc('totalCashflow' + element.scenario.code)">
                                } @else {
                                    {{ element.totalCashflow | traceableFormat }}
                                }
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="navMultiple">
                            <th mat-header-cell *matHeaderCellDef>NAV Multiple</th>
                            <td mat-cell *matCellDef="let element">
                                @if (isEditable) {
                                    <input matInput
                                           class="input-number-narrow"
                                           type="text"
                                           inputmode="decimal"
                                           formControlName="navMultiple{{element.scenario.code}}"
                                           id="navMultiple{{element.scenario.code}}"
                                           (change)="calc('navMultiple' + element.scenario.code)">
                                } @else {
                                    {{ element.navMultiple | traceableFormat }}
                                }
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="primaryNetTvpi">
                            <th mat-header-cell *matHeaderCellDef>Primary nTVPI</th>
                            <td mat-cell *matCellDef="let element">{{ element.finalFundNTvpi | traceableFormat }}</td>
                        </ng-container>

                        <ng-container matColumnDef="pattern">
                            <th mat-header-cell *matHeaderCellDef>Pattern</th>
                            <td mat-cell *matCellDef="let element">{{ getAssignedTopDownValuationPattern(element) | traceableFormat }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="topDownValuation.tableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: topDownValuation.tableColumns"></tr>
                    </table>
                }
            </mat-card-content>
            <mat-card-actions class="detail-card-actions">
                @if (!isEditable) {
                    <button (click)="edit()"
                            [disabled]="(isEditDisabled$ | async)!"
                            color="primary"
                            data-test="edit-button"
                            mat-icon-button>
                        <mat-icon>edit</mat-icon>
                    </button>
                }
                @if (isEditable) {
                    <button (click)="save()"
                            [disabled]="topDownValuationForm.invalid || saveBlock?.disabled"
                            [matTooltip]="saveBlock?.tooltip ?? ''"
                            color="primary"
                            data-test="save-button"
                            mat-icon-button>
                        <mat-icon>save</mat-icon>
                    </button>
                }
                @if (isEditable) {
                    <button (click)="cancel()"
                            color="primary"
                            data-test="cancel-button"
                            mat-icon-button>
                        <mat-icon>cancel</mat-icon>
                    </button>
                }
                <valumize-card-comments-button [commentScope]="'fund-report-valuation'" [commentSlug]="'fund-top-down-valuation'"></valumize-card-comments-button>
            </mat-card-actions>
        }
    </mat-card>
</form>
